import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/frontend/node_modules/.pnpm/next@15.5.19_@babel+core@7.29.7_@playwright+test@1.60.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/vercel/path0/frontend/src/app/components/landing/site-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/frontend/src/app/components/landing/site-header.tsx");
